import { actions as receivedActions } from '@app/action/transfers-received';
import { actions as transferActions } from '@app/action/transfer';
import { normalizeTransfer } from '@module/transfer/build';

export const initialState = {
  isLoaded: false,
  list: [],
};

export default function(state = initialState, action) {
  const { type } = action;

  if (type === receivedActions.RECEIVED_TRANSFERS_SUCCESS) {
    return {
      ...state,
      list: action.list.map(normalizeTransfer),
      isLoaded: true,
    };
  }

  if (
    state.isLoaded &&
    type === transferActions.TRANSFER_STATE_DOWNLOADING &&
    action.transferId
  ) {
    return {
      ...state,
      list: state.list.map((receivedTransfer) => {
        if (
          receivedTransfer.transfer &&
          receivedTransfer.recipient &&
          receivedTransfer.recipient.downloaded === false &&
          receivedTransfer.transfer.id === action.transferId
        ) {
          return {
            ...receivedTransfer,
            recipient: {
              ...receivedTransfer.recipient,
              downloaded: true,
            },
          };
        }
        return receivedTransfer;
      }),
    };
  }

  return state;
}
